import ButtonComponent from "./ButtonComponent";
import { getSecureItemFromSpecificStorage, storeSecureItemInSpecifiedStorage } from "../lib/BrowserStorageAccessMiddleware";
import { LOCAL_STORAGE, TXN_ID, LS_CUSTOMER, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS, SS_REDIRECTED_FROM_LOGIN, LS_DOMAIN_AND_LOCKER_BANK, LS_LOCKER_BANK_INFO, LS_BOOKING_TYPE, ADVANCE_BOOKING, SESSION_STORAGE, SS_PAYMENT_GATEWAY, SS_PAYMENT_GATEWAY_ACCESS_KEY } from "../assets/constants/BrowserStorageKeys";
import { HIVEBOARD, PARCEL_USE_CASE, SUCCESS } from "../assets/constants/Constants";
import { advancereserveLocker, buildBulkPaymentInitial, sendOtp, verifyOtp } from "../api/api";
import { useLocation, useHistory } from 'react-router-dom';
import { getAssignedLockers, GetAvailableLockerSizesAndRedirectUser, getPathForNextPage, handleStoreUserDataInLocalStorage } from "../lib/Utils";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { HOME, LOGIN } from "../assets/constants/PageList";

const OtpInput = ({ length = 4, userInput , bookingObject }) => {
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const [timeLeft, setTimeLeft] = useState(60);
  const [status, setStatus] = useState("idle");
  const [showProgress, setShowProgress] = useState(true);
  const [showTick, setShowTick] = useState(false);
  const [isResendLoading, setIsResendLoading] = useState(false);
  const history = useHistory();
  const inputsRef = useRef([]);
  const assignemntSettings = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS);
  const lockerBankId = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_DOMAIN_AND_LOCKER_BANK)?.lockerBankId;
  const lockerBankInfo = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_LOCKER_BANK_INFO);
  const hasBookingObject = Boolean(bookingObject);
  console.log("bookingObject lenght is :" , hasBookingObject);
  useEffect(() => {
    if (timeLeft <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  /* otp change method */
  const handleChange = async (value, index) => {
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value.slice(-1);
    setOtp(newOtp);

    if (value && index < length - 1) {
      inputsRef.current[index + 1].focus();
    }

    const joinedOtp = newOtp.join("");

    if (joinedOtp.length === length) {
      try {
        const txn_id = getSecureItemFromSpecificStorage(
          LOCAL_STORAGE,
          TXN_ID
        );

        const response = await verifyOtp(txn_id, joinedOtp);
        console.log(" response for verify otp is: ", response);

        if (response?.status === SUCCESS) {
          setStatus("success");
          setShowProgress(true);
          let userInfo = response.data;
          handleStoreUserDataInLocalStorage(userInfo)
          // here we need to check if there is advance-booking respose then we need to call the reserve api and payment 
          // else below one 
          // redirect user based on setting s
          const bookingtype = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_BOOKING_TYPE )
          console.log("bookingtype : ", bookingtype);
          if(bookingObject && bookingtype === ADVANCE_BOOKING ){
            // call the reserver api for advancebooking
            try {
              const reserveLockerResponse = await advancereserveLocker(bookingObject);
              console.log("responsedata :", reserveLockerResponse);
              if(reserveLockerResponse.data?.status === 'success'){
                // show toast message for succsfull reserver locker in advance
                // now call the payment api  but for now just comments only 
                const object = {
                  "payment_gateway": reserveLockerResponse?.data?.data?.assignment_payment_gateway?.payment_gateway,
                  "booking_id": reserveLockerResponse?.data?.data?.ref_id,
                  "locker_bank_id": bookingObject?.locker_bank_id,
                  "amount": bookingObject?.total_price,
                  "accept_payment_mode": "default"
                }
                // initial payent call api then lunch the payment
                console.log(" payment object is :", object); 
                const prepaymentResponse = await buildBulkPaymentInitial(object);
                console.log("payment response is :", prepaymentResponse);
                if(reserveLockerResponse?.data?.status == "success"){
                  //redirect to payment page with payload 
                  const temp = reserveLockerResponse?.data?.data;
                  const lockerUnitDetails = {
                    ref_id: temp?.ref_id,
                    is_already_opened_once: false,
                    locker_bank: {
                        name: temp?.locker_bank_name
                    },
                    locker_door: {
                        door_no: temp?.door_no
                    }
                };

                const lockerData = {
                      reservedLocker: temp,
                      locker_bank: {
                          name: temp?.locker_bank_name,
                          location: {
                              name: temp?.locker_bank_location
                          }
                      },
                      assignment: {
                          payment_gateway: [ temp?.assignment_payment_gateway ]
                      },
                      payment_records: [
                          { amount: prepaymentResponse?.data?.data?.amount }
                      ],
                      user: {
                          username:  prepaymentResponse?.data?.data?.user?.username,
                          email: prepaymentResponse?.data?.data?.user?.email,
                          mobile_number: prepaymentResponse?.data?.data?.user?.mobile_number
                      }
                  };
                  storeSecureItemInSpecifiedStorage(SESSION_STORAGE, SS_PAYMENT_GATEWAY, temp?.assignment_payment_gateway?.payment_gateway);
                  storeSecureItemInSpecifiedStorage(SESSION_STORAGE, SS_PAYMENT_GATEWAY_ACCESS_KEY, prepaymentResponse?.data?.data?.order_id);
                  history.replace({
                      pathname: '/payment-details',
                      state: {
                          lockerUnitDetails,
                          isLockerReservedTillSuccessfulPayment: true,
                          lockerData,
                          // paymentGateway: prePaymentResponse?.data?.data?.payment_gateway,
                          currentReferenceId: prepaymentResponse?.data?.data?.order_id,
                          // paymentGatewayAccessKey: prePaymentResponse?.data?.data?.payment_gateway_reference
                      }
                  });
                }
                

              }
            } catch (error) {
              // show toast message for error show 
                console.log("error happend during advance bokking", error)
            }
            
            return ;
          }
          else{
          let assignLockerList = await getAssignedLockers(assignemntSettings.id);
          const assigndata = assignLockerList?.data;
          // handle for Hive board and durolt 
          if (getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_CUSTOMER) === HIVEBOARD) {
                sessionStorage.setItem(SS_REDIRECTED_FROM_LOGIN, true);
                if (assigndata.length >= 1) {
                    history.push(getPathForNextPage(LOGIN, HOME));
                    return;
                }
                else{
                    history.push(getPathForNextPage(LOGIN, HOME));
                }
            } 
          else {
			if (assigndata.length >= 1) {
				history.push(getPathForNextPage(LOGIN, HOME));
				return;
			}
			else {
				await GetAvailableLockerSizesAndRedirectUser(lockerBankInfo, lockerBankId, userInfo?.id, assignemntSettings?.is_pricing, history);
			}
          }
          }
		    setShowProgress(false);
        setShowTick(true);
        } else {
          throw new Error("Invalid OTP");
        }
      } catch (error) {
        console.error("OTP Error:", error);

        setStatus("error");
        setShowProgress(true);

        setTimeout(() => {
          setShowProgress(false);
        }, 800);
      }
    } else {
      setStatus("idle");
      setShowTick(false);
      setShowProgress(true);
    }
  };

  /* BACKSPACE handler*/
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  /*RESEND handler*/
  /**
 * Resends the OTP to the user.
 * 
 * @async
 * @function resendOTP
 * @returns {Promise<void>} A promise that resolves when the OTP is successfully resent.
 * @throws {Error} If an error occurs while resending the OTP.
 */
  const handleResend = useCallback(async () => {
    try {
      setIsResendLoading(true);
      await new Promise((res) => setTimeout(res, 1500));

      // Reset OTP state
      setOtp(new Array(length).fill(""));
      setTimeLeft(25);
      setStatus("idle");
      setShowTick(false);
      setShowProgress(true);

      // focus first input
      inputsRef.current[0]?.focus();
      let assignmentSlug = assignemntSettings?.slug;
      if (assignmentSlug && userInput) {
        const response = await sendOtp(userInput, assignmentSlug, true);
        if (response.status === SUCCESS) {
          let txnId = response?.data?.txn_id;
          storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, TXN_ID, txnId);
        } else {

        }
      }
    } catch (error) {
      console.error("Resend Error:", error);
    } finally {
      setIsResendLoading(false);
    }
  }, [length]);


  const progress = (otp.filter((d) => d !== "").length / length) * 100;

  return (
    <div className="otp-container">
      <div className="otp-left">
        <p className="otp-title">
          Please enter OTP sent to {userInput}
        </p>

        {/* OTP INPUTS */}
        <div className="otp-group">
          <div className="otp-input-wrapper">
            {otp.map((digit, index) => (
              <input
                key={index}
                type="text"
                maxLength="1"
                value={digit}
                ref={(el) => (inputsRef.current[index] = el)}
                onChange={(e) =>
                  handleChange(e.target.value, index)
                }
                onKeyDown={(e) =>
                  handleKeyDown(e, index)
                }
                className={`otp-input 
                  ${status === "error" ? "error" : ""} 
                  ${status === "success" ? "success" : ""}`}
              />
            ))}

            {showTick && <span className="otp-success">✔</span>}
          </div>

          {/* PROGRESS BAR */}
          {showProgress && (
            <div className="otp-progress">
              <div
                className={`otp-progress-bar 
                  ${status === "success" ? "success" : ""} 
                  ${status === "error" ? "error" : ""}`}
                style={{
                  width:
                    status !== "idle"
                      ? "100%"
                      : `${progress}%`,
                }}
              />
            </div>
          )}
        </div>

        {/* ERROR */}
        {status === "error" && (
          <p className="otp-error-text">
            Wrong entered OTP
          </p>
        )}

        {/* TIMER */}
        <p className="otp-timer">
          Code valid for{" "}
          <span className="time">
            0:{timeLeft < 10 ? `0${timeLeft}` : timeLeft}
          </span>
        </p>
      </div>

      {/* BUTTON */}
      <ButtonComponent
        align="right"
        type="custom"
        title={isResendLoading ? "Resinging.." : "Reset OTP"}
        handleClick={handleResend}
        disabled={isResendLoading}
      />
    </div>
  );

};




export default OtpInput;